<template>
  <div class="Feedback" :class="[`Feedback--${type}`]" :style="width">
    <Icon
      class="Feedback__icon"
      :iconName="type === 'success' ? 'Success' : 'Error'"
    />
    <div class="Feedback__inner">
      <p class="Feedback__heading">{{ heading }}</p>
      <span v-if="supplement" class="Feedback__supplement">{{
        supplement
      }}</span>
    </div>
  </div>
</template>

<script>
import Icon from '@spectee/components/Atoms/IconBase/index.vue';

export default {
  name: 'FeedbackBase',
  components: { Icon },
  props: {
    heading: {
      type: String,
      default: '',
    },
    supplement: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      validator: function (value) {
        return ['success', 'info', 'warning', 'error'].indexOf(value) !== -1;
      },
      default: 'success',
    },
    size: {
      type: Number,
      default: 280,
    },
  },
  computed: {
    width() {
      return {
        '--width': `${this.size}px`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

$feedback-styles: (
  'success': (
    'background-color': $color-green-10,
    'border': 1px solid $color-green-60,
    'color': $color-green-60,
  ),
  'info': (
    'background-color': $color-blue-10,
    'border': 1px solid $color-blue-60,
    'color': $color-blue-60,
  ),
  'warning': (
    'background-color': $color-yellow-10,
    'border': 1px solid $color-yellow-60,
    'color': $color-yellow-60,
  ),
  'error': (
    'background-color': $color-red-10,
    'border': 1px solid $color-red-70,
    'color': $color-red-70,
  ),
);

.Feedback {
  position: fixed;
  right: $service-unit * 10;
  bottom: $service-unit * 10;
  display: flex;
  align-items: center;
  width: var(--width);
  padding: $service-unit * 3 $service-unit * 2;
  border-radius: $service-border-radius;
  box-shadow: $service-shadow-mp;
  z-index: $service-z-index-ff;

  @each $type, $style in $feedback-styles {
    &--#{$type} {
      background-color: map-get($style, 'background-color');
      border: map-get($style, 'border');
    }
  }

  & &__icon {
    flex-shrink: 0;
    width: $service-unit * 5;
    height: $service-unit * 5;
  }

  @each $type, $style in $feedback-styles {
    &--#{$type} &__icon {
      color: map-get($style, 'color');
    }
  }

  &__inner {
    flex-grow: 1;
    margin-left: $service-unit * 2;
    text-align: left;
  }

  &__heading {
    font-size: $service-font-size-mp;
    font-weight: bold;
  }

  &__supplement {
    display: block;
    font-size: $service-font-size-pp;
    color: $color-gray-70;
  }
}

.v-enter-active {
  animation: fadeInAnimation 0.5s ease 0.5s 1 normal backwards;
}

.v-leave-active {
  animation: fadeOutAnimation 0.5s ease 0.5s 1 normal backwards;
}

@keyframes fadeInAnimation {
  from {
    opacity: 0;
    transform: translateX($service-unit * 10);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeOutAnimation {
  from {
    transition: opacity 1;
  }

  to {
    opacity: 0;
  }
}
</style>
